import { createStyles, Theme, WithStyles, withStyles } from '@material-ui/core'
import React from 'react'
import { Route, Switch } from 'react-router'

import Main from '../../Main/Main'
import NotFoundLanding from '../NotFoundLanding'

interface MainLandingProps extends WithStyles<typeof styles> {
	onAuthFail?: () => void
}

const MainLanding: React.FC<MainLandingProps> = (props: MainLandingProps) => {
	const { classes, onAuthFail } = props

	return (
		<div className={classes.root}>
			<Switch>
				<Route exact={true} path="" render={(mainProps) => <Main {...mainProps} onAuthFail={onAuthFail} />} />
				<Route component={NotFoundLanding} />
			</Switch>
		</div>
	)
}

const styles = (theme: Theme) =>
	createStyles({
		root: {
			flex: 1,
			marginTop: `${theme.spacing.unit}px`,
			[theme.breakpoints.up('lg')]: {
				width: '70%',
			},
			[theme.breakpoints.up('md')]: {
				width: '80%',
			},
			[theme.breakpoints.only('sm')]: {
				width: '65%',
			},
			[theme.breakpoints.only('xs')]: {
				width: '90%',
			},
		},
	})

export default withStyles(styles)(MainLanding)
